import React from "react";
import { NavLink as Link } from "react-router-dom";
import { Instagram, Twitter, Facebook, MessageCircle, Mail } from "lucide-react";
import { useHelpContact, helpWaUrl, helpMailUrl } from "@/lib/helpContact";

const FLINK = "vb-foot-link inline-flex items-center gap-1 py-0.5 rounded-md whitespace-nowrap";
// No dedicated support page exists; support is the existing VerB WhatsApp help line.

export default function Footer() {
  const help = useHelpContact();
  const supportWa = helpWaUrl(help);
  return (
    <footer className="bg-slate-900 text-slate-300 mt-16" data-testid="app-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="inline-block leading-tight bg-white rounded-xl px-3 py-2 shadow-sm" data-testid="footer-wordmark">
                <div className="font-display text-2xl font-bold text-black leading-none tracking-tight">Ver<span className="text-emerald-700">B</span></div>
                <div className="text-[10px] font-semibold tracking-[0.16em] text-black mt-0.5 whitespace-nowrap">Vertual <span className="text-emerald-700">Bazaar</span></div>
              </div>
            </div>
            <p className="text-sm max-w-md leading-relaxed text-slate-400">
              India ka apna local marketplace. Products, services aur naukri — sab ek jagah,
              aapke pincode ke aas-paas. Small businesses ko digital taakat.
            </p>
            <div className="flex items-center gap-3 mt-6">
              <a href="#" className="p-2 rounded-full bg-slate-800 hover:bg-emerald-700 transition-colors" aria-label="Instagram"><Instagram className="w-4 h-4" /></a>
              <a href="#" className="p-2 rounded-full bg-slate-800 hover:bg-emerald-700 transition-colors" aria-label="Twitter"><Twitter className="w-4 h-4" /></a>
              <a href="#" className="p-2 rounded-full bg-slate-800 hover:bg-emerald-700 transition-colors" aria-label="Facebook"><Facebook className="w-4 h-4" /></a>
            </div>
          </div>
          <div>
            <div className="text-white font-semibold mb-4">Explore</div>
            <ul className="space-y-2 text-sm text-slate-400">
              <li><Link to="/category/products" className={FLINK}>Products</Link></li>
              <li><Link to="/category/services" className={FLINK}>Services</Link></li>
              <li><Link to="/category/hiring" className={FLINK}>Hiring</Link></li>
              <li><Link to="/category/shops" className={FLINK}>Local Shops</Link></li>
            </ul>
          </div>
          <div>
            <div className="text-white font-semibold mb-4">For Vendors</div>
            <ul className="space-y-2 text-sm text-slate-400" data-testid="footer-vendor-links">
              <li><Link to="/onboarding" className={FLINK} data-testid="footer-become-seller">Become a Seller</Link></li>
              <li><Link to="/vendor" className={FLINK} data-testid="footer-vendor-dashboard">Vendor Dashboard</Link></li>
              <li><Link to="/category/hiring" className={FLINK} data-testid="footer-post-job">Post a Job</Link></li>
              <li><a href={supportWa || undefined} target="_blank" rel="noopener noreferrer" className={FLINK} data-testid="footer-support">Support <span className="text-xs text-slate-500">(WhatsApp)</span></a></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-slate-800 mt-12 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <div>© 2026 VerB — Vertual Bazaar. Made with love in India.</div>
          <div>Prototype build · Real payments not enabled.</div>
        </div>
        <div className="mt-4 pt-4 border-t border-slate-800/60 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-3 text-center min-w-0" data-testid="footer-credit">
          <span className="text-[10px] uppercase tracking-[0.2em] text-slate-500">Prepared by</span>
          <span className="font-display text-sm font-semibold text-white" data-testid="footer-credit-name">Kamlesh Srivastava</span>
          <span className="hidden sm:inline text-slate-700">|</span>
          <div className="flex flex-wrap items-center justify-center gap-2 max-w-full">
            {help && <a href={helpMailUrl(help)} className="inline-flex items-center gap-1.5 max-w-full rounded-full border border-slate-700 hover:border-emerald-500 hover:text-emerald-400 px-3 py-1 text-xs text-slate-300 transition-colors break-all" data-testid="footer-credit-email"><Mail className="w-3.5 h-3.5 flex-shrink-0" /><span className="break-all">{help.email}</span></a>}
            {help && <a href={supportWa} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 rounded-full border border-slate-700 hover:border-emerald-500 hover:text-emerald-400 px-3 py-1 text-xs text-slate-300 transition-colors" data-testid="footer-whatsapp-link"><MessageCircle className="w-3.5 h-3.5" />WhatsApp</a>}
          </div>
        </div>
      </div>
    </footer>
  );
}
